import styled from 'styled-components';

export const Introduction = styled.p`
  max-width: 60ch;
`;
